import React, { Component } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';

interface Source {
    name: string;
    performancesTotal: number;
}

interface Props {
    data: Source[];
}

const chartDivId = 'sources-overview';
const hideSmall = (hidden: boolean, target: Record<string, unknown>): boolean =>
    _get(target, ['dataItem', 'values', 'value', 'percent'], 0) < 0.5;

export class SourcesOverview extends Component<Props> {
    private chart: am4charts.PieChart | null = null;

    componentDidMount(): void {
        const { data } = this.props;
        const chart = am4core.create(chartDivId, am4charts.PieChart);
        const pieSeries = chart.series.push(new am4charts.PieSeries());

        chart.data = data;

        pieSeries.dataFields.value = 'performancesTotal';
        pieSeries.dataFields.category = 'name';
        pieSeries.slices.template.stroke = am4core.color('#fff');
        pieSeries.slices.template.strokeWidth = 2;
        pieSeries.slices.template.strokeOpacity = 1;
        // eslint-disable-next-line
        // @ts-ignore
        pieSeries.ticks.template.adapter.add('hidden', hideSmall);
        // eslint-disable-next-line
        // @ts-ignore
        pieSeries.labels.template.adapter.add('hidden', hideSmall);

        // This creates initial animation
        pieSeries.hiddenState.properties.opacity = 1;
        pieSeries.hiddenState.properties.endAngle = -90;
        pieSeries.hiddenState.properties.startAngle = -90;

        this.chart = chart;
    }

    componentDidUpdate(prevProps: Props): void {
        const { data } = this.props;
        const { chart } = this;

        if (chart !== null) {
            if (!_isEqual(prevProps.data, data)) {
                chart.data = data;
            }
        }
    }

    componentWillUnmount(): void {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    render(): JSX.Element {
        return (
            <div id={chartDivId} style={{ width: '100%', height: '500px' }} />
        );
    }
}
